import { UnitOfMeasure } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_DISPLAY_UNIT_OF_MEASURE } from "@/constants/resultsLimits";



export function useDisplayUnitOfMeasure() {
  const { geotabClient } = useGeotabClient();
    return useQuery({
        queryKey: ["displayUnitOfMeasure"],

        queryFn: async ({ signal }): Promise<UnitOfMeasure[]> => {
            return geotabClient.call("Get", { typeName: "DisplayUnitOfMeasure", resultsLimit: RESULTS_LIMIT_DISPLAY_UNIT_OF_MEASURE }, signal);
        }
    });
}
